module.exports = __webpack_public_path__ + "img/eth.008e9061.png";